import { render, staticRenderFns } from "./CecUnmTagCloudList.vue?vue&type=template&id=ffc15c8a&scoped=true"
import script from "./CecUnmTagCloudList.vue?vue&type=script&lang=js"
export * from "./CecUnmTagCloudList.vue?vue&type=script&lang=js"
import style0 from "./CecUnmTagCloudList.vue?vue&type=style&index=0&id=ffc15c8a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc15c8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffc15c8a')) {
      api.createRecord('ffc15c8a', component.options)
    } else {
      api.reload('ffc15c8a', component.options)
    }
    module.hot.accept("./CecUnmTagCloudList.vue?vue&type=template&id=ffc15c8a&scoped=true", function () {
      api.rerender('ffc15c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/cecunmtagcloud/CecUnmTagCloudList.vue"
export default component.exports